<template>
  <div class="CreateLibraryPropertyComponent">

    <b-form>

      <b-form-group id="input-group-1" :label="lang.label_Name" label-for="input-2">
        <b-form-input id="input-Name" v-model="form.name" :placeholder="lang.placeholder_Name" size="sm" required
          aria-describedby="input-Name-feedback" :state="validation_name"></b-form-input>

        <b-form-invalid-feedback id="input-Name-feedback" :state="validation_name">
          {{lang.validinfo_1}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-2" :label="lang.label_Type" label-for="input-3">
        <b-form-select id="input-Type" v-model="form.type" :options="types" size="sm" required
          aria-describedby="input-Type-feedback" :state="validation_type"></b-form-select>
        <b-form-invalid-feedback id="input-Type-feedback" :state="validation_type">
          {{lang.validinfo_2}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-3">
        <b-form-checkbox-group v-model="form.checked" id="checkboxes-4">
          <b-form-checkbox value="isRequiredOnRequest">{{lang.label_Request}}</b-form-checkbox><br>
          <b-form-checkbox value="isRequiredOnRelease">{{lang.label_Release}}</b-form-checkbox><br>
          <b-form-checkbox value="isRevisionChanging">{{lang.label_Revision}}</b-form-checkbox><br>
          <b-form-checkbox v-if="isHDL" value="hdlGlobal">{{lang.label_HdlGlobal}}</b-form-checkbox>


        </b-form-checkbox-group>
        
        <!-- <span v-if="isCIS">
          <hr>
          <b-form-group id="input-group-5" :label="lang.label_CisDesignation" label-for="input-3">
            <b-form-select
              id="input-Type"
              v-model="form.cisDesignation"
              :options="designationTypes"
              size="sm"
              required
              aria-describedby="input-Designation-feedback"
              :state="validation_designation"
            ></b-form-select>
            <b-form-invalid-feedback id="input-Designation-feedback" :state="validation_designation">
              {{lang.validinfo_3}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-checkbox-group
            v-model="form.checked"
            id="checkboxes-6"
          >
            
            <b-form-checkbox value="cisBrowsable">{{lang.label_CisBrowsable}}</b-form-checkbox>
          </b-form-checkbox-group>
        </span> -->
      </b-form-group>


    </b-form>
  </div>
</template>

<script>



export default {
  name: "CreateLibraryPropertyComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {

        name: '',
        type: null,
        checked: []
      },
      types: [],
      inputStatus: null
    }
  },
  computed: {
    // isCIS(){
    //   return this.$store.getters.isCIS;
    // },
    // designationTypes(){
            
    //   const tab = [];
    //   for (let i = 0, lei = this.lang.CISDesignationTypes.length; i < lei; i++){
                      
    //     tab.push({value: i, text: this.lang.CISDesignationTypes[i]});
                  
    //   }
    //   return tab;
    // },
    existingTypes(){
      return this.$store.getters.existingTypes;
    },
    validation_name() {
      if (this.form.name.length == 0){
        return null;
      }
      return this.form.name.length > 0
    },
    validation_type() {
      if (this.form.type == null){
        return null;
      }
      return this.form.type != null
    },
    isHDL() {
      return this.$store.getters.appConf.status.isHDL;
    },
    // validation_designation() {
    //   if (this.form.cisDesignation == null){
    //     return null;
    //   }
    //   return this.form.cisDesignation != null
    // }
  },
  created() {

    let _vue = this;

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPropertiesType")
    .then(function(result) {
      
      console.log(result.data)


      for (let i = 0, lei = result.data.length; i < lei; i++){

        
        if (!_vue.existingTypes.includes(result.data[i]) || ((result.data[i] == "text") || (result.data[i] == "link"))){
          _vue.types.push({value:result.data[i], text:result.data[i]});
        }else{
          _vue.types.push({value:result.data[i], text:result.data[i], disabled: true});
        }
        
      }

    })
  },
  updated(){
    

    this.$store.dispatch("createPropertyForm", this.form);
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .CreateLibraryPropertyComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/CreateLibraryPropertyComponent.vue